const { getLocaleFromMarket } = require('@site/utils');

module.exports = async (market = 'en-US') => {
  const locale = getLocaleFromMarket(market);
  return await import(`./${locale}.json`);
};
